import { AppBar, Toolbar, Typography, Box, IconButton, Stack } from "@mui/material";
import BottomNav from "./BottomNav";
import { useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { AccountCircle } from "@mui/icons-material";

import StatusIndicator from "../components/StatusIndicator";
import LeafletEnquiryMenuButton from "./LeafletEnquiryMenuButton";

export default function AppLayout({ children, headerAction, headerActions }: {
  children: ReactNode;
  headerAction?: ReactNode;
  headerActions?: ReactNode;
}) {
  const location = useLocation();

  const title =
    location.pathname.startsWith("/settings/offline")
      ? "Offline"
      : location.pathname.startsWith("/settings")
      ? "Settings"
      : location.pathname.startsWith("/coverage/near-me")
      ? "Coverage Near Me"
      : location.pathname.startsWith("/coverage/district-map")
      ? "District Map"
      : location.pathname.startsWith("/coverage")
      ? "Coverage"
      : location.pathname.startsWith("/reports/maps")
      ? "Map Report"
      : location.pathname.startsWith("/reports/coverage-clusters")
      ? "Coverage Clusters"
      : location.pathname.startsWith("/reports/coverage-heatmap")
      ? "Coverage Heatmap"
      : location.pathname.startsWith("/reports/coverage")
      ? "Coverage Report"
      : location.pathname.startsWith("/reports/status")
      ? "Status Report"
      : location.pathname.startsWith("/reports/agent")
      ? "Agent Report"
      : location.pathname.startsWith("/reports")
      ? "Reports"
      : location.pathname.startsWith("/note-map")
      ? "Note Map"
      : location.pathname.startsWith("/sync")
      ? "Sync"
      : location.pathname.startsWith("/address/")
      ? "Address"
      : "Canvass";

  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100%" }}>
      <AppBar
        position="fixed"
        elevation={1}
        sx={{
          backgroundColor: "primary.main",
          color: "white",
          paddingTop: "env(safe-area-inset-top)",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", minHeight: 56 }}>
          <Box sx={{ minWidth: 48, display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
            {headerAction ?? null}
          </Box>

          <Typography variant="h6" sx={{ flex: 1, textAlign: "center" }}>
            {title}
          </Typography>

          <Box sx={{ minWidth: 80, display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <StatusIndicator />
              <LeafletEnquiryMenuButton />
              {headerActions ?? null}
              <IconButton size="large" edge="end" color="inherit">
                <AccountCircle />
              </IconButton>
            </Stack>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="main"
        sx={{
          paddingTop: "calc(56px + env(safe-area-inset-top))",
          paddingBottom: "calc(64px + env(safe-area-inset-bottom))",
        }}
      >
        {children}
      </Box>

      <BottomNav />
    </Box>
  );
}


// import { AppBar, Toolbar, Typography, Box, IconButton } from "@mui/material";
// import BottomNav from "./BottomNav";
// import { useLocation } from "react-router-dom";
// import type { ReactNode } from "react";
// import { AccountCircle } from "@mui/icons-material";

// export default function AppLayout({ children, headerAction }: {
//   children: ReactNode;
//   headerAction?: ReactNode;   // ← make optional
// }) {
//   const location = useLocation();

//   const title =
//     location.pathname.startsWith("/settings")
//       ? "Settings"
//       : location.pathname.startsWith("/address/")
//       ? "Address"
//       : "Canvass";

//   return (
//     <Box sx={{ bgcolor: "background.default", minHeight: "100%" }}>
//       {/* Header */}
//       <AppBar
//         position="fixed"
//         elevation={1}
//         sx={{
//           backgroundColor: "primary.main",
//           color: "white",
//           paddingTop: "env(safe-area-inset-top)",
//         }}
//       >
//         <Toolbar sx={{ justifyContent: "space-between", minHeight: 56 }}>
//           <Box sx={{ width: 32 }}>{headerAction ?? null}</Box>
//           <Typography variant="h6" sx={{ flex: 1, textAlign: "center" }}>
//             {title}
//           </Typography>
//           {/* <Box sx={{ width: 32 }} /> */}

//  <Box sx={{ width: 32 }}>
//              <IconButton
//               size="large"
//               edge="end"
//               aria-label="account of current user"
//               // aria-controls={menuId}
//               aria-haspopup="true"
//               // onClick={handleProfileMenuOpen}
//               color="inherit"
//             >
//               <AccountCircle />
//             </IconButton>
//           </Box>

//         </Toolbar>
//       </AppBar>

//       {/* Content (no scroll container here) */}
//       <Box
//         component="main"
//         sx={{
//           paddingTop: "calc(56px + env(safe-area-inset-top))",
//           paddingBottom: "calc(64px + env(safe-area-inset-bottom))",
//         }}
//       >
//         {children}
//       </Box>

//       <BottomNav />
//     </Box>
//   );
// }
